/** Merges block metadata indicators with V2 block outputs for the data table source rows. */
export default function mergeDataTableSourceRows(
  indicatorValues: any[] | null | undefined,
  metadataIndicators: any[],
  indicatorHeaders: any[],
): any[] {
  const metadataById = new Map(metadataIndicators.map((m: any) => [m.id, m]));

  if (indicatorValues?.length) {
    return indicatorValues.map((row: any) => {
      const metadataId = row?.chevronType === 'child' ? row?.parentId : row?.id;
      const meta = metadataById.get(metadataId);
      if (!meta) return row;

      return {
        ...row,
        type: meta.format ?? meta.type ?? row?.type,
        indicator_type: meta.indicator_type ?? row?.indicator_type,
        warning: meta.warning ?? row?.warning,
        name: row?.chevronType === 'child' ? row?.name ?? meta.name : meta.name ?? row?.name,
      };
    });
  }

  if (!indicatorHeaders?.length || metadataIndicators.length === 0) return [];

  return metadataIndicators.map((meta: any, index: number) => ({
    id: meta?.id ?? index,
    name: meta?.name ?? '',
    type: meta?.format ?? meta?.type ?? 'Number',
    indicator_type: meta?.indicator_type ?? 'input',
    warning: meta?.warning ?? [],
    total_values: indicatorHeaders.map((header: any) => ({
      name: header?.name,
      value: 0,
    })),
  }));
}
